export const GET_REFUND_PAYMENTS = 'GET_REFUND_PAYMENTS';
export const GET_REFUND_PAYMENT_BY_ID = 'GET_REFUND_PAYMENT_BY_ID';
export const REFUND_PAYMENT_ADMIN_VERIFICATION =
  'REFUND_PAYMENT_ADMIN_VERIFICATION';
